import {
  SaveTreatmentPrescriptionModal,
  ViewTreatmentPrescriptionModal,
} from 'components/organisms/TreatmentPrescription';
import { TreatmentConsultationProvider, useTreatmentOnGoing } from 'context';
import React from 'react';

import { Stack } from '@mui/material';

import { SaveTreatmentConsultationModal } from '../SaveTreatmentConsultationModal';
import { TreatmentConsultationHeader } from '../TreatmentConsultationHeader';
import { TreatmentConsultationTable } from '../TreatmentConsulttionTable';
import { ViewTreatmentConsultationModal } from '../ViewTreatmentConsultationModal';

interface Props {
  visible: boolean;
}

export const TreatmentConsultationTab: React.FC<Props> = ({ visible }) => {
  const { treatmentOnGoing } = useTreatmentOnGoing();

  if (!treatmentOnGoing?.id) {
    return null;
  }

  return (
    <TreatmentConsultationProvider
      petId={treatmentOnGoing.pet?._id}
      treatmentOnGoingId={treatmentOnGoing?.id}
    >
      {visible && (
        <Stack display="flex" flexDirection="column" flex={1}>
          <TreatmentConsultationHeader />

          <TreatmentConsultationTable />
        </Stack>
      )}

      <SaveTreatmentConsultationModal />

      <SaveTreatmentPrescriptionModal />

      <ViewTreatmentConsultationModal />

      <ViewTreatmentPrescriptionModal />
    </TreatmentConsultationProvider>
  );
};
